let stripeJsLoadPromise = null;

const loadStripeJs = () => {
    if (window.Stripe) return Promise.resolve(window.Stripe);
    if (stripeJsLoadPromise) return stripeJsLoadPromise;

    stripeJsLoadPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://js.stripe.com/v3/';
        script.async = true;
        script.onload = () => {
            if (window.Stripe) resolve(window.Stripe);
            else reject(new Error('Stripe.jsの読み込みに失敗しました。'));
        };
        script.onerror = () => reject(new Error('Stripe.jsの読み込みに失敗しました。'));
        document.head.appendChild(script);
    });

    return stripeJsLoadPromise;
};

export const handleStripeNextAction = async ({ clientSecret, publishableKey, isEnglishBeta = false }) => {
    if (!clientSecret || !publishableKey) {
        throw new Error(isEnglishBeta ? 'Payment authentication details were missing.' : '決済認証情報を取得できませんでした。');
    }

    const StripeConstructor = await loadStripeJs();
    const stripe = StripeConstructor(publishableKey);
    const result = typeof stripe.handleNextAction === 'function'
        ? await stripe.handleNextAction({ clientSecret })
        : await stripe.confirmCardPayment(clientSecret);

    if (result.error) {
        throw new Error(result.error.message || (isEnglishBeta ? 'Payment authentication failed.' : '決済の追加認証に失敗しました。'));
    }
    if (!result.paymentIntent || !['succeeded', 'processing'].includes(result.paymentIntent.status)) {
        throw new Error(isEnglishBeta ? 'Payment authentication was not completed.' : '決済の追加認証が完了しませんでした。');
    }
    return result.paymentIntent;
};
